import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';

const RetractionConfirmModal = ({
  isOpen,
  formData,
  onConfirm,
  onClose,
  confirmLoading,
  isSAV,
  retraction,
}) => {
  const getRecapText = () => {
    return `Ticket : ${formData?.ticketReference}
Commande : ${formData?.orderReference}
Demande : ${
      (formData?.retractionType || retraction?.type) === 'total'
        ? 'Totale'
        : 'Partielle'
    }
Motif : ${formData?.reason || retraction?.reason?.name}

Frais et remboursements
Montant de la commande : ${
      formData?.orderAmount || retraction?.refund?.amountTotal
    }${getSymbolFromCurrency(
      formData?.currencyCode || retraction?.returnFees?.currency?.code
    )}
${
  formData?.productsAmount
    ? `Montant total des produits rétractés : ${
        formData?.productsAmount
      }${getSymbolFromCurrency(formData?.currencyCode)}\n`
    : ''
}
Frais de rétractations : ${
      formData?.retractFeeAmount || retraction?.returnFees?.amount
    }${getSymbolFromCurrency(
      formData?.currencyCode || retraction?.returnFees?.currency?.code
    )}
Remboursement à effectuer : ${
      formData?.refundAmount || retraction?.refund?.amountTotal
    }${getSymbolFromCurrency(
      formData?.currencyCode || retraction?.returnFee?.currency?.code
    )}
${
  isSAV
    ? `Si deuxième commande (50% des frais à rembourser) : ${
        formData?.partialRefundAmount
      }${getSymbolFromCurrency(formData?.currencyCode)}`
    : ''
}
Colis à rétracter : ${
      formData?.selectedPackages?.length || retraction?.packages?.length
    } Colis

${
  !isSAV
    ? `Information client
Nom, Prénom : ${formData?.firstName} ${formData?.lastName}
Téléphone : ${formData?.phone}

Adresse d'enlèvement
${formData?.address1}
${formData?.address2 || ''}
${formData?.postalCode} ${formData?.city} - ${formData?.country}

Date et heure de l'enlèvement
${format(new Date(formData?.pickUpDate), 'dd MMMM yyyy', { locale: fr })}, ${
        formData?.pickUpTime
      }

${
  formData?.trackingNumber && formData?.carrier
    ? `Transporteur : ${formData?.carrier}
Numéro de suivi : ${formData?.trackingNumber}`
    : ''
}`
    : ''
}`;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(getRecapText());
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Récapitulatif de la demande de rétractation</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, my: 2 }}>
          <Typography>
            <strong>Ticket :</strong> {formData?.ticketReference}
          </Typography>
          <Typography>
            <strong>Commande :</strong> {formData?.orderReference}
          </Typography>
          <Typography>
            <strong>Demande :</strong>{' '}
            {(formData?.retractionType || retraction?.type) === 'total'
              ? 'Totale'
              : 'Partielle'}
          </Typography>
          <Typography>
            <strong>Motif :</strong>{' '}
            {formData?.reason || retraction?.reason?.name}
          </Typography>
          <Typography
            variant="h6"
            color="primary"
            sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
          >
            Frais et remboursements
          </Typography>
          <Typography>
            <strong>Montant de la commande :</strong>{' '}
            {formData?.orderAmount || retraction?.refund?.amountTotal}
            {getSymbolFromCurrency(
              formData?.currencyCode || retraction?.returnFees?.currency?.code
            )}
          </Typography>
          {formData?.productsAmount && (
            <Typography>
              <strong>Montant total des produits rétractés :</strong>{' '}
              {formData?.productsAmount}
              {getSymbolFromCurrency(formData?.currencyCode)}
            </Typography>
          )}
          <Typography>
            <strong>Frais de rétractations :</strong>{' '}
            {formData?.retractFeeAmount || retraction?.returnFees?.amount}
            {getSymbolFromCurrency(
              formData?.currencyCode || retraction?.returnFees?.currency?.code
            )}
          </Typography>
          <Typography>
            <strong>Remboursement à effectuer :</strong>{' '}
            {formData?.refundAmount || retraction?.refund?.amountTotal}
            {getSymbolFromCurrency(
              formData?.currencyCode || retraction?.returnFee?.currency?.code
            )}
          </Typography>
          {isSAV && (
            <Typography>
              <strong>
                Si deuxième commande (50% des frais à rembourser) :
              </strong>{' '}
              {formData?.partialRefundAmount}
              {getSymbolFromCurrency(formData?.currencyCode)}
            </Typography>
          )}
          <Typography>
            <strong>Colis à rétracter :</strong>{' '}
            {formData?.selectedPackages?.length || retraction?.packages?.length}{' '}
            Colis
          </Typography>

          {/* Nouvelles informations client */}
          {!isSAV && (
            <>
              <Typography
                variant="h6"
                color="primary"
                sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
              >
                Information client
              </Typography>
              <Typography>
                <strong>Nom, Prénom :</strong> {formData?.firstName}{' '}
                {formData?.lastName}
              </Typography>
              <Typography>
                <strong>Téléphone :</strong> {formData?.phone}
              </Typography>
              {/* Nouvelle section adresse */}
              <Typography
                variant="h6"
                color="primary"
                sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
              >
                Adresse d&apos;enlèvement
              </Typography>
              <Typography>{formData?.address1}</Typography>
              {formData?.address2 && (
                <Typography>{formData?.address2}</Typography>
              )}
              <Typography>
                {formData?.postalCode} {formData?.city} - {formData?.country}
              </Typography>

              {/* Date et heure d'enlèvement */}
              <Typography
                variant="h6"
                color="primary"
                sx={{ fontSize: '1em', fontWeight: 'bold', mt: 1 }}
              >
                Date et heure de l&apos;enlèvement
              </Typography>
              <Typography>
                {format(new Date(formData?.pickUpDate), 'dd MMMM yyyy', {
                  locale: fr,
                })}
                , {formData?.pickUpTime}
              </Typography>

              {formData.trackingNumber && formData.carrier && (
                <Box sx={{ mt: 1 }}>
                  <Typography>
                    <strong>Transporteur :</strong> {formData.carrier}
                  </Typography>
                  <Typography>
                    <strong>Numéro de suivi :</strong> {formData.trackingNumber}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
        {isSAV && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Typography>
              <i>
                À la confirmation, un nouveau ticket sera créé à destination du
                SLO
              </i>
              <br />
              <i>
                Votre commentaire sera ajouté à ce ticket avec toutes les
                informations de la rétractation.
              </i>
            </Typography>
          </Box>
        )}
        {!isSAV && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Typography>
              <i>
                À la confirmation, votre commande sera &quot;En cours de
                rétractation&quot;.
              </i>
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button onClick={onClose}>Fermer</Button>
        <Box>
          <Button
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
            variant="outlined"
            color="primary"
          >
            Copier
          </Button>
          <Button
            onClick={onConfirm}
            disabled={confirmLoading}
            startIcon={
              confirmLoading ? <CircularProgress size={16} /> : <DoneIcon />
            }
            variant="contained"
            color="primary"
            sx={{ ml: 1 }}
          >
            Confirmer
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default RetractionConfirmModal;
